/**
 * spaceLootDrawBuilders.ts
 * Camera-relative rect builder for live Star Seed loot pickups.
 *
 * Extracted from {@link ./spaceDrawBuilders} so the parent file stays
 * under the AGENTS.md 300-line cap. No game-state writes — pure read of
 * {@link spaceState.loot} into a list of `SpaceRect`s for the renderer.
 *
 * @module spaceLootDrawBuilders
 */

import { spaceState } from '../engine/spaceState';
import { SPACE_STAR_SEED_COLOR } from '../../constants/spaceLootConstants';
import type { SpaceRect } from './spaceRenderTypes';

/**
 * Build camera-relative rectangles for every uncollected Star Seed
 * loot pickup in the active scene.
 *
 * @param cameraX - Current camera left-edge X.
 * @returns One {@link SpaceRect} per live pickup.
 */
export function buildLootRects(cameraX: number): SpaceRect[] {
  const out: SpaceRect[] = [];
  for (const s of spaceState.loot) {
    if (s.dead || s.collected) continue;
    out.push({
      x: s.x - cameraX,
      y: s.y,
      width: s.width,
      height: s.height,
      color: SPACE_STAR_SEED_COLOR,
      // DECISION: `l` prefix (loot) keeps seed keys distinct from
      // shard (`cs`), mine (`m`), boss-bolt (`bp`), missile (`bm`),
      // and shield-node (`bs`) streams.
      key: `l${s.spawnId}`,
    });
  }
  return out;
}
